var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dots-pagination"},_vm._l((_vm.length),function(n,idx){return _c('button',{key:`dot-${idx}`,class:[
            'dots-pagination__dot',
            { 'dots-pagination__dot--active': idx === _vm.current }],attrs:{"aria-label":`view banner ${idx}`,"disabled":idx === _vm.current},on:{"click":function($event){return _vm.handleClick(n - 1)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }